import React from 'react';
import { getFileType, getFileIcon } from '../utils/fileHandler';
import { formatFileSize } from '../utils/dataMapping';

const AttachmentCard = ({ file, baseUrl }) => {
  if (!file) return null;

  const fileType = getFileType(file.name || file.file_name);
  const { icon, color } = getFileIcon(fileType);
  const fileSize = formatFileSize(file.size);
  const fileUrl = `${baseUrl}${file.file_path || file.path}`;

  const handleDownload = () => {
    window.open(fileUrl, '_blank');
  };

  const handleImagePreview = () => {
    if (fileType === 'image') {
      window.open(fileUrl, '_blank');
    }
  };

  return (
    <div
      onClick={fileType === 'image' ? handleImagePreview : undefined}
      className={`
        flex items-center gap-3 bg-gray-50 p-3 rounded-md border border-gray-100
        cursor-pointer hover:bg-gray-100 transition-colors w-fit
        ${fileType === 'image' ? 'pr-12' : ''}
      `}
    >
      <div className="bg-gray-200 p-2 rounded flex items-center justify-center">
        <span className={`text-2xl ${color}`}>{icon}</span>
      </div>
      <div>
        <p className="text-sm font-medium leading-tight text-gray-700">
          {file.name || file.file_name}
        </p>
        <p className="text-xs text-gray-400">{fileSize}</p>
        {fileType === 'image' && (
          <p className="text-xs text-blue-500 mt-1">Click to preview</p>
        )}
      </div>
      {fileType !== 'image' && (
        <button
          onClick={handleDownload}
          className="ml-auto text-gray-500 hover:text-gray-700 transition-colors"
          title="Download file"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default AttachmentCard;
